import React from "react";

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  footer: {
    textAlign: "center",
    padding: theme.spacing(2, 0),
    backgroundColor: theme.palette.primary.main,
    marginTop: "30px",
  },
  fontSize: {
    fontSize: "16px",
    [theme.breakpoints.down('sm')]: {
      fontSize: "12px"
    }
  },
}));

const Footer = () => {
  const classes = useStyle();
  return (
    <footer className={classes.footer}>
      <Typography variant="button" color="secondary" className={classes.fontSize}>
        {"SISTEM INFORMASI PENERIMAAN CALON ANGGOTA BARU KSR PMI UNIT UNJ"}
      </Typography>
    </footer>
  );
};

export default Footer;
